import classplusLogo from "../../assets/Images/classplus-logo.png";
import messageEdit from "../../assets/Images/message-edit.svg";
import playCircle from "../../assets/Images/play-cricle.svg";
import announce from "../../assets/Images/Announce.svg";
import {conversationsEG } from "../../data/contents";
import { ButtonTexts } from "../../data/contents";
import "./headings.css";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import globe from "../../assets/Images/globe.png";
import posterimg from "../../assets/Images/postermodalimg.jpg";
import closemodalicon from "../../assets/Images/closemodalicon.jpeg";
import redDot from "../../assets/Images/redDot.svg";
import axios from "axios";
import { baseUrl } from "../../utils/api";
import i18n from "../../i18n";
import ModalCross from "../../assets/Images/modal-cross.svg";
import { useMediaQuery } from "react-responsive";
import trackEvent from "../utils";

const Headings = ({
  language,
  setMobileLan,
  setMobileCommunityUrl,
  userInputs,
  setMobileUid,
  isNumberSubmitted,
  coachingName,
  showRadarScreen,
  mobileLan,
}) => {
  const { t } = useTranslation();
  const [uid,setUid]=useState()
  const [headingTexts , setHeadingTexts] = useState()
  const [headingText, setHeadingText] = useState();
  const [buttonText, setButtonText] = useState(language === "EN" ? "Telugu":"English")
  const [showButton, setShowButton] = useState(false) 
  const [apiSet, setApiSet]=useState()
  const isSmallScreen = useMediaQuery({ query: "(max-width: 800px)" });
  
  const [showModal, isShowModal] = useState(false);
  const [posterModal, setPosterModal] = useState(false)
  const [liveNow, isLiveNow] = useState(false);

  useEffect(() => {
    setMobileLan(localStorage.getItem('lang'))
    const url = new URL(window.location.href);
    let utm_source = url.searchParams.get("utm_source");
    let utm_campaign = url.searchParams.get("utm_campaign");
    let utm_medium = url.searchParams.get("utm_medium");
    let utm_content = url.searchParams.get("utm_content");
    let utm_term = url.searchParams.get("utm_term");
    let gclID = url.searchParams.get("gclid");
    getUUID(utm_campaign, utm_medium, utm_source, utm_content, utm_term, gclID);

    if(isSmallScreen) {
      sessionStorage.setItem("poster-triggered", true);
      setTimeout(() =>{
          if(sessionStorage.getItem("poster-triggered") === "true"){
            setPosterModal(true)
            isLiveNow(true)
            sessionStorage.setItem("poster-triggered", false);
          }
      },7000)
    }
  }, []);

  const getUUID = async (
    utm_campaign,
    utm_medium,
    utm_source,
    utm_content,
    utm_term,
    gclID
  ) => {
    try {
      const fbp = document.cookie
        .split(";")
        .filter((c) => c.includes("_fbp="))
        .map((c) => c.split("_fbp=")[1]);
      const fbc = document.cookie
        .split(";")
        .filter((c) => c.includes("_fbc="))
        .map((c) => c.split("_fbc=")[1]);

      let fbpCookie = fbp && fbp[0];
      let fbcCookie = fbc && fbc[0];

      const { data } = await axios.post(`${baseUrl}/growth/saveLead`, {
        utm_campaign,
        utm_medium,
        utm_source,
        utm_content,
        utm_term,
        gclId: gclID,
        fbp: fbpCookie,
        fbc: fbcCookie,
        leadIntent:"clp-old",
      });
      setUid(data.data);
      setMobileUid(data?.data)
      const lang=data?.data?.languageDetails?.language?.toUpperCase() ? data?.data?.languageDetails?.language?.toUpperCase() : 'EN';
      if(!localStorage.getItem('lang')){
        localStorage.setItem("lang",lang);
      }
      let updateLocalLanguage =  localStorage.getItem('lang');
      setMobileLan(updateLocalLanguage)
      i18n.changeLanguage(updateLocalLanguage)
      setApiSet(lang)
      setHeadingText(conversationsEG?.[`${updateLocalLanguage}`][1]);
      setMobileCommunityUrl(data?.data?.languageDetails?.communityUrl)
      setShowButton(lang === "EN" ? false:true)
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(()=>{
    if(localStorage.getItem('lang')=== 'EN')
    {
      setButtonText(ButtonTexts?.[`${apiSet}`])
      setHeadingText(conversationsEG?.[`${language}`]?.[1])
    }
  },[apiSet])

  const handleLanguages = ()=>{
    if(localStorage.getItem('lang')=='EN'){
      localStorage.setItem('lang',apiSet)
    } else{
      localStorage.setItem('lang','EN')
    }
    window.location.href='/';
  }
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
    setHeadingText(conversationsEG?.[`${language}`]?.[1]);
    setHeadingTexts(conversationsEG?.[`${mobileLan}`]);
    let index = 0;
    const interval = setInterval(() => {
      if (index < headingTexts?.length - 1) {
        setHeadingText(headingTexts[index + 1]);
        index++;
      } else {
        index = 0;
        setHeadingText(headingTexts?.[index]);
      }
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, [mobileLan,headingTexts]);

  return (
    <div className={userInputs[Object.keys(userInputs)[0]] ? `heading` : ""}>
      <div className="nav-mobile-view">
      <img width={150} alt="classplus-logo" src={classplusLogo} />
      {
        showButton ? (
          <div className="nav-lang-box" onClick={handleLanguages}>
          <img src={globe} alt="globe" />
          <p>{buttonText}</p>
        </div>
        ) : ""
      }
      
      </div>

      <h3 className="text-2xl mt-6 text-colorHeading font-semibold" style={{marginTop: "60px"}}>
        {isNumberSubmitted ? (
          <>
            {showRadarScreen ? (
              null
            ) : (
              <>
                <span className="border-b-4  border-colorWhite">
                  {t("components.Headings.Hi", "Hi")}
                </span>
                , {coachingName}
              </>
            )}
          </>
        ) : (
          <>
            <span style={{color:"#FFE668"}}>
           {t("components.Headings.Free Pentab", "Get A Complete Studio Setup!")}
            </span>
            <br/>
            <span className="text-colorWhite  border-colorHeading  " style={{fontSize:"20px" , lineHeight:"20px"}}>
              {t("components.Headings.Book your teaching app","Book your Teaching App today and get a Studio Setup for FREE.")}
            </span>
          </>
        )}
      </h3>

      

      
    </div>
  );
};

export default Headings;
